// Spinner.js
import React from 'react';
import './Spinner.css'; // Make sure to create this CSS file

function Spinner() {
    return (
        <div className="spinner"></div>
    );
}

export default Spinner;